﻿import $ from 'jquery';
import { ErrorPopover, IClearErrorOptions } from "./errorpopover";
import { FormValidation, IValidationHandler } from "./formvalidation";
import { FieldValidationHandler } from "./fieldvalidationhandler";

export class MultiSelectDropdownValidationHandler implements IValidationHandler {
  handle($error: JQuery): boolean {
    let $field = $error.prev('[data-multiselect]');
    let isMultiSelect = $field.length > 0;
    if (!isMultiSelect)
      return false;

    if ($field.data('error-handled') == true)
      return true;

    let errorMessage = $error.html();
    $field.data('error-handled', true);
    $field.addClass(FormValidation.validationClass);

    $error.remove();

    let id = $field.find('[data-popover]').data('popover') + '-error';
    let $userFacingInput = $field.find('[data-ms-user-facing-input]');
    let $realInput = $field.find('[data-ms-real-input]');
    new ErrorPopover().append($userFacingInput, id, errorMessage, 'none', {
      clearErrorWireups: [
        { $targetInput: $userFacingInput, triggerEvents: 'change input' },
        { $targetInput: $realInput, triggerEvents: 'change' }
      ],
      onErrorPopoverDisabled: () => {
        this.onErrorPopoverDisabled($field);
        this.onErrorPopoverDisabled($userFacingInput);
      }
    } as IClearErrorOptions);

    return true;
  }

  private onErrorPopoverDisabled($field: JQuery): void {
    $field.removeClass(FormValidation.validationClass);
  }
}
